export default (text, length, suffix = "...") => {
  if (!text) {
    return ""
  }
  if (text.length > length) {
    return text.substring(0, length) + suffix
  } else {
    return text
  }
}
